import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Select from 'react-select'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

import styles from './LegalDocs.module.scss'

const LegalDocs = ({
  agreements,
  title,
  legalVersions = [],
  headerClassName = '',
  contentClassNames = '',
  initialVersion = null
}) => {
  const [legalAgreements, setLegalAgreements] = useState(agreements)
  const [versions, setVersions] = useState([])
  const [defaultVersion, setDefaultVersion] = useState(initialVersion)

  useEffect(() => {
    const formatOptions = (versionsArr) => {
      return versionsArr.map((version, id) => {
        return {
          label: `Version ${version}`,
          value: version,
          id
        }
      })
    }

    if (legalVersions.length > 0) setVersions(formatOptions(legalVersions))
  }, [])

  const handleVersionChange = async (version) => {
    const apiUrl = `${publicRuntimeConfig.legalApiBaseUrl}/api/v1/legalDoc/${agreements[0].legalType}?version=${version}`
    const response = await fetch(apiUrl)
    response
      .json()
      .then((res) => {
        setLegalAgreements([res.data])
        setDefaultVersion(null)
      })
      .catch((err) => console.error(err))
  }

  const getVersion = (agreementVersion) => {
    if (defaultVersion > agreementVersion || !defaultVersion) return agreementVersion
    return defaultVersion
  }

  return (
    legalAgreements &&
    legalAgreements.map((agreement, index) => (
      <React.Fragment key={index}>
        <h2 className={classNames(styles.titleHeader, 'pageH2', 'text-center', headerClassName)}>
          {title || agreement.title}
        </h2>
        {versions.length > 0 && (
          <Select
            name="selectedVersion"
            options={versions}
            onChange={(value) => handleVersionChange(value.value)}
            className={classNames(styles.versionDropdown, 'mb-3')}
            hideSelectedOptions={true}
            defaultValue={{
              label: `Version ${getVersion(agreement.version)}`,
              value: getVersion(agreement.version)
            }}
          />
        )}
        <div dangerouslySetInnerHTML={{ __html: agreement.body }} className={contentClassNames} />
      </React.Fragment>
    ))
  )
}

export default LegalDocs
